const _questions = [
  { question: "Tell us a bit about yourself.", placeholder: "Just the juicy bits." },
  {
    question: "Why do you want to be a Member of The Battery?",
    placeholder: "What was your “a-ha!” moment?"
  },
  {
    question: "How do you plan on using the club?",
    placeholder: "We want you to have the best experience possible."
  },
  {
    question: "If you hosted a Member Event, what would it be?",
    placeholder: "Our interest is spiked already."
  },
  {
    question: "Why should you be chosen as the next Battery Member?",
    placeholder: "Go ahead, brag a little."
  }
];

export default _questions;
